import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { OrderForm } from "./OrderForm";
import { OrderCard } from "./OrderCard";

const OrderLayout = () => {
  const dispatch = useDispatch();
  const { exploreList } = useSelector((state) => state.exploreReducer);
  const explorelist = exploreList.usr?.rec || [];

  useEffect(() => {
    // Fetch new order details from local storage when the component mounts
    const newOrderDetails = JSON.parse(localStorage.getItem("newOrder"));
    if (newOrderDetails) {
      // Dispatch an action to update the Redux store with the new order details
      dispatch({ type: "SET_NEW_ORDER_DETAILS", payload: newOrderDetails });
    }
  }, [dispatch]);

  return (
    <div>
      {explorelist.length > 0 ? (
        <OrderCard exploreList={explorelist} />
      ) : (
        <OrderForm />
      )}
    </div>
  );
};

export default withRouter(OrderLayout);
